import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EditorImg from 'lowcode/components/EditorImg';

const EURank = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('referral');

    return (
        <div className={styled.eu_rank}>
            <div className="container">
                <div className="eu_rank_text">
                    <div className="eu_rank_subtitle">{t('rankinglist.bottom_subtitle')}</div>
                    <div className="eu_rank_title">{t('rankinglist.bottom_title')}</div>
                    <div className="eu_rank_desc">{t('rankinglist.bottom_desc')}</div>
                </div>
                <div className="eu_rank_img">
                    <EditorImg
                        className="img"
                        pc={'https://websiteoss.ecoflow.com/upload/image/1726043198018/rank_reward_pc.png'}
                        pad={'https://websiteoss.ecoflow.com/upload/image/1726043198018/rank_reward_pc.png'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1726046208747/rank_reward_m.png'}
                    />
                </div>
                <div className="eu_rank_subtitle_m">{t('rankinglist.bottom_subtitle')}</div>
            </div>
        </div>
    );
};

export default EURank;
